
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.493 5.16c4.086 2.86 4.787 8.781 1.118 12.45-3.669 3.67-9.59 2.97-12.45-1.117L.208 9.158l3.638-1.475L0 0l7.683 3.847L9.158.21l7.335 4.951zM7.62 7.62a5.885 5.885 0 000 8.326 5.895 5.895 0 008.326 0 5.894 5.894 0 000-8.326 5.895 5.895 0 00-8.326 0zm7.492.832a4.716 4.716 0 010 6.661 4.716 4.716 0 01-6.662 0 4.708 4.708 0 010-6.661 4.716 4.716 0 016.662 0z","fill":"#F8BF1E"}})])
          )
        }
      }
    